module.exports = {
    checkout: {
        staffDiscountLabel: 'Team Member Discount',
        eVoucherDisplayName: 'eVoucher',
        zeroPaymentDisplayMessage: 'Your balance is less or equal to zero. Please submit your order.',
        isNewCheckoutConfirmBehavior: false,
        b2bTsAndCsDisclaimer:
        '<p>By placing this order, you confirm that you agree to Woolworths <a href="https://www.woolworthsonline.com.au/shop/discover/shopping-online/my-business-terms-and-conditions" target="_blank">terms and conditions</a> (including our <a href="https://www.woolworthsonline.com.au/Shop/Discover/about-us/privacy-policy" target="_blank">privacy policy</a>).</p>',
        b2cTsAndCsDisclaimer:
            '<p>By placing this order, you confirm that you agree to Woolworths <a href="https://www.woolworthsonline.com.au/Shop/Discover/about-us/terms-and-conditions" target="_blank">terms and conditions</a> (including our <a href="https://www.woolworthsonline.com.au/Shop/Discover/about-us/privacy-policy" target="_blank">privacy policy</a>).</p>',
        restrictedByCrowdDeliveryMessage: "Sorry, these products aren't available for your chosen window",
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/checkout.js